import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LifeBuoy, BookOpen, Send } from "lucide-react";
import { useUser } from "@/store/useUser";
import { hasAnyPolicy } from "@/lib/policies";
export const Support: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const canReadKnowledgeBase = hasAnyPolicy(user, ['tools:support:knowledgebase~read']);

  const goToTrainingCenter = () => {
    navigate("/support/training");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-6 py-10 space-y-6">
        <div className="flex items-start gap-3">
          <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
            <LifeBuoy className="h-6 w-6" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Support</h1>
            <p className="text-sm text-gray-600 mt-1">
              Access required training and find help resources.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {canReadKnowledgeBase ? (
            <Card className="shadow-sm">
              <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2 text-gray-900">
                  <BookOpen className="h-5 w-5 text-blue-600" />
                  Knowledge Base
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <p className="text-sm text-gray-600">Review support procedures, troubleshooting steps, and response guidance.</p>
                <Button
                  id="support-knowledge-base-button"
                  variant="secondary"
                  onClick={() => navigate('/support/knowledge-base')}
                  className="gap-2"
                >
                  <BookOpen className="h-4 w-4" />
                  Open Knowledge Base
                </Button>
              </CardContent>
            </Card>
          ) : null}
          <Card className="shadow-sm">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-gray-900">
                <BookOpen className="h-5 w-5 text-blue-600" />
                Training
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <p className="text-sm text-gray-600">Access compliance and educational trainings without leaving Support.</p>
              <div className="flex flex-col gap-3">
                <Button
                  id="support-training-center-button"
                  variant="secondary"
                  onClick={goToTrainingCenter}
                  className="gap-2 shrink-0"
                >
                  <BookOpen className="h-4 w-4" />
                  Training Center
                </Button>
              </div>
            </CardContent>
          </Card>
          <Card className="shadow-sm">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-gray-900">
                <Send className="h-5 w-5 text-blue-600" />
                eFax Submission
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <p className="text-sm text-gray-600">
                Submit a court correspondence fax packet using the secure captcha form.
              </p>
              <Button
                id="support-efax-form-button"
                variant="secondary"
                onClick={() => navigate("/support/efax")}
                className="gap-2"
              >
                <Send className="h-4 w-4" />
                Open eFax Form
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};
